module.exports = __webpack_public_path__ + "img/Stemness-BRCA_10X_Section2.565ab5e9.png";